/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.0.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'

// router setup
import routes from './routes/routes'

import './registerServiceWorker'

//Bootstrap vue setup
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/fr';
import 'element-ui/lib/theme-chalk/index.css';
//import enLocale from 'element-ui/lib/locale/lang/fr';


import CKEditor from '@ckeditor/ckeditor5-vue2';

import './assets/css/style.css'
import './assets/css/style_menu.css'
import './assets/css/index.css'
import VueSelect from 'vue-select2'
//import 'https://unpkg.com/select-combobox/dist/combobox.css'
//import 'https://unpkg.com/select-combobox/dist/combobox.js'
//import  Vuetify from 'vuetify/lib';
//import 'vuetify/dist/vuetify.min.css';



import axios from 'axios';
import Vuex from "vuex";
// Vue.use(require('vue-moment'), {
//     moment
// })
/*import "https://cdn.dhtmlx.com/scheduler/codebase/dhtmlxscheduler.js" 
import "https://cdn.dhtmlx.com/scheduler/codebase/sources/locale/locale_fr.js" 
import "https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_timeline.js" 
import "https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_treetimeline.js" 
import "https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_daytimeline.js" 
import "https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_multisection.js" 
import "https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_limit.js" 
import "https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_units.js" 
import "https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_multiselect.js" 
import "https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_tooltip.js" 
import "https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_quick_info.js" */

Vue.use(Vuex);
import storePlugin from './store/index.js'
Vue.use(storePlugin)
Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(ElementUI, { locale })
Vue.use(LightBootstrap)

const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)
Vue.use( CKEditor );
Vue.component('VueSelect', VueSelect);
 
const moment = require('moment')
require('moment/locale/fr')

Vue.use(require('vue-moment'), {
    moment
}) 



/*import {*} from  'https://cdn.dhtmlx.com/scheduler/codebase/dhtmlxscheduler.js';
import {*} from  'https://cdn.dhtmlx.com/scheduler/codebase/sources/locale/locale_fr';
import {*} from  'https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_timeline.js';
import {*} from  'https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_treetimeline.js';
import {*} from  'https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_daytimeline.js';
import {*} from  'https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_multisection.js';
import {*} from  'https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_limit.js';
import {*} from  'https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_units.js';
import {*} from  'https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_multiselect.js';
import {*} from  'https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_tooltip.js';
import {*} from  'https://cdn.dhtmlx.com/scheduler/codebase/ext/dhtmlxscheduler_quick_info.js';*/
//Axios setup

import  'dhtmlx-scheduler'
import  "dhtmlx-scheduler/codebase/dhtmlxscheduler.js"
import  "dhtmlx-scheduler/codebase/sources/locale/locale_fr.js" 
// import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_timeline.js" 
//import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_treetimeline.js" 
//import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_daytimeline.js" 
//import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_multisection.js" 
import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_limit.js" 
// import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_units.js" 
import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_multiselect.js" 
import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_tooltip.js" 
import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_quick_info.js"
//import ElementUI from 'element-ui';
//import 'element-ui/lib/theme-chalk/index.css';
//import enLocale from 'element-ui/lib/locale/lang/fr'

/*import "bootstrap/dist/js/bootstrap.min.js"
import "jquery/dist/jquery.min.js"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-fileinput/css/fileinput.min.css"
import "bootstrap-fileinput/js/plugins/piexif.min.js"
import "bootstrap-fileinput/js/plugins/sortable.min.js"
import "popper.js/dist/umd/popper.min.js"
import "bootstrap-fileinput/js/fileinput.min.js"
import "bootstrap-fileinput/themes/explorer-fa/theme.js"
import "bootstrap-fileinput/js/locales/fr.js"*/



const opts = {}

//export default new Vuetify(opts)
// configure router
const router = new VueRouter({
  mode: "hash",
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store: storePlugin,
  render: h => h(App),
  router
})
